import { TFunction } from "next-i18next";

import { PageContentProps } from "content/content.types";
import { mergeContent } from "utils/mergeContent";
import contacts from "configs/contacts";
import { SocialTypes } from "constants/enum";

import defaultContent from "./common";
import { UrlsConfig } from "../../../configs/urlsConfig";

export default (t: TFunction, pageContent: PageContentProps) => {
    const { locale } = pageContent;
    const content = defaultContent(t, pageContent);
    return mergeContent(content, {
        contacts: {
            wa: {
                text: t("navigationMenuRelaunch:navigationWhatsApp"),
                link: contacts.whatsapp[locale].link,
                newPatientsLink: (contacts.whatsapp[locale] as any)
                    .newPatientsLink,
                message: t("global:whatsappMessage"),
            },
        },
        footer: {
            company: {
                links: [
                    ...content.footer.company.links,
                    {
                        id: "studentbeans",
                        name: t("navigationMenuRelaunch:studentBeans"),
                        link: UrlsConfig.STUDENT_BEANS,
                    },
                ],
            },
            product: {
                title: t("global:productFooterText"),
                links: [
                    {
                        name: t("navigationMenuRelaunch:clusterBDiastema"),
                        link: UrlsConfig.DIASTEMA,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBOverbite"),
                        link: UrlsConfig.OVERBITE,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBCrossbite"),
                        link: UrlsConfig.CROSSBITE,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBCrookedTeeth"),
                        link: UrlsConfig.CROOKED_TEETH,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBCrowding"),
                        link: UrlsConfig.CROWDING,
                    },
                ],
            },
            support: {
                links: content.footer.support.links.map((link) => {
                    if (link?.id !== SocialTypes.WA) return link;
                    return {
                        id: SocialTypes.WA,
                        name: "WhatsApp",
                        link: "https://api.whatsapp.com/send/?phone=34613738467&text&type=phone_number&app_absent=0",
                    };
                }),
            },
        },
    });
};
